import React, { useMemo, useEffect } from 'react';
import { EmojiContext } from './EmojiContext';
export const EmojiContextProvider = ({
  children,
  emojiContextValue
}) => {
  const memoizedEmojiContextValue = useMemo(() => emojiContextValue, [emojiContextValue]);
  useEffect(() => {
    // trigger emoji fetching
    async function fetchEmojiProvider() {
      await (memoizedEmojiContextValue === null || memoizedEmojiContextValue === void 0 ? void 0 : memoizedEmojiContextValue.emoji.emojiProvider.fetchEmojiProvider());
    }

    fetchEmojiProvider();
  }, [memoizedEmojiContextValue]);
  return /*#__PURE__*/React.createElement(EmojiContext.Provider, {
    value: memoizedEmojiContextValue
  }, children);
};